export const DIRECT_CONTENT = {
  title: 'Direct Rollover',
  body: [
    {
      id: 'direct-info-bullet-1',
      disc:
        'Your provider either sends your money directly to us or sends you a check.'
    },
    {
      id: 'direct-info-bullet-2',
      disc:
        'Your check is made out to T. Rowe Price for the benefit of (FBO) your name.'
    },
    {
      id: 'direct-info-bullet-3',
      disc: 'There are no current income taxes or penalties with this option.'
    }
  ]
};

export const INDIRECT_CONTENT = {
  title: 'Indirect Rollover',
  body: [
    {
      id: 'indirect-info-bullet-1',
      disc: 'Your employer sends you a check made out in your name.'
    },
    {
      id: 'indirect-info-bullet-2',
      disc:
        'You then have 60 days to move your money into a Rollover IRA, including an amount to make up any taxes withheld, to avoid current taxation on that amount.'
    }
  ]
};
